import { render, staticRenderFns } from "./files-tab.vue?vue&type=template&id=767af33e&scoped=true"
import script from "./files-tab.vue?vue&type=script&lang=js"
export * from "./files-tab.vue?vue&type=script&lang=js"
import style0 from "./files-tab.vue?vue&type=style&index=0&id=767af33e&prod&scoped=true&lang=css"
import style1 from "./files-tab.vue?vue&type=style&index=1&id=767af33e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767af33e",
  null
  
)

export default component.exports